// app/frontend/pages/RecurringEvents/Index.tsx
import React from 'react';
import { Head, usePage, PageProps } from '@inertiajs/react';
import { Container, Title, Text, Grid } from '@mantine/core';

import { StablePagination } from '../../components/StablePagination';
import '../../styles/RecurringEventCard.css';

import { RecurringEventCard } from '../../components/ui';

interface RecurringEvent {
  id: number;
  title: string;
  slug: string;
  image?: string | null;
  recurrence_pattern: string;
  number_of_occurrences: number;
}

interface PaginationMeta {
  current_page: number;
  total_pages: number;
  total_count: number;
  per_page: number;
}

interface RecurringEventsIndexProps {
  recurring_events: RecurringEvent[];
  pagination: PaginationMeta;
  event?: {
    id: number;
    name: string;
    slug: string;
  };
}

export default function RecurringEventsIndex() {
  const { recurring_events, pagination, event } = usePage<PageProps & { props: RecurringEventsIndexProps }>().props;

  const pageTitle = event ? `${event.name} - Recurring Events` : 'Recurring Events';
  const headingTitle = event ? `Recurring Events for ${event.name}` : 'Recurring Events';

  return (
    <>
      <Head title={`${pageTitle} | WhereCanWeDance.com`} />

      <Container size="md" my="xl">
        <Title order={1} mb="lg" c="white" className="rubik" style={{ marginBottom: '40px' }}>
          {headingTitle}
        </Title>

        {recurring_events.length > 0 ? (
          <>
            {pagination.total_pages > 1 && (
              <StablePagination
                total={pagination.total_pages}
                value={pagination.current_page}
                onChange={(page) => {
                  const baseUrl = event ? `/re?event_id=${event.id}` : '/re';
                  const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}page=${page}`;
                  window.location.href = url;
                }}
              />
            )}

            <Grid my="lg" gutter="md">
              {recurring_events.map((recurringEvent) => (
                <Grid.Col key={recurringEvent.id} span={{ base: 12, sm: 4, lg: 4 }}>
                  <RecurringEventCard recurringEvent={recurringEvent} />
                </Grid.Col>
              ))}
            </Grid>

            {pagination.total_pages > 1 && (
              <StablePagination
                total={pagination.total_pages}
                value={pagination.current_page}
                onChange={(page) => {
                  const baseUrl = event ? `/re?event_id=${event.id}` : '/re';
                  const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}page=${page}`;
                  window.location.href = url;
                }}
              />
            )}
          </>
        ) : (
          <Text c="dimmed">No recurring events.</Text>
        )}
      </Container>
    </>
  );
}
